import { type z } from 'zod';

import { unitySearchParams } from '@@containers/Search/unitySearchParams';

/** The search params of the content lists */
export const overviewListSearchParams = unitySearchParams.pick({
    q: true,
    page: true,
    sort: true,
    tenantIds: true,
    userIds: true,
    contentStatus: true,
    publicationStatus: true,
    categoryIds: true,
    tagIds: true,
    publishedBefore: true,
    publishedAfter: true,
});

export type OverviewListSearchParams = z.output<typeof overviewListSearchParams>;
